import React from "react";
import { Separator } from "@/components/ui/separator";
const partners = [{
  id: 1,
  name: "GAF",
  logo: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/GAF-logo-696x497-1.jpg?v=xcnd22pma58"
}, {
  id: 2,
  name: "James Hardie",
  logo: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/OIP-1-1.webp?v=ssk4bcepx6p"
}, {
  id: 3,
  name: "Owens Corning",
  logo: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/346-3467772_owens-corning-logo-png-transparent-owens-corning-logo.png?v=nk4jpzl0a6p"
}, {
  id: 4,
  name: "Pella",
  logo: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/2143665.webp?v=i8f6wo33skj"
}, {
  id: 5,
  name: "Andersen",
  logo: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/photo.jpg?v=xls0go6ipt"
}, {
  id: 6,
  name: "Trex",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/partner_logo_trex.png"
}, {
  id: 7,
  name: "CertainTeed",
  logo: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/CertainTeed-Symbol-scaled.png?v=3kkm0chdu2x"
}, {
  id: 8,
  name: "Velux",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/partner_logo_velux.png"
}];
export default function OurPartnersAndCertificates() {
  const tickerItems = [...partners, ...partners];
  return <section data-section-id="224705" id="verified-reliability" className="bg-background text-foreground relative py-16 overflow-hidden flex flex-col items-center justify-center">
      {}
      <Separator className="absolute top-0 w-full bg-border h-[1px]" />

      <style>{`
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          display: flex;
          width: max-content;
          animation: ticker-scroll 40s linear infinite;
        }
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="container mx-auto px-4 mb-10 text-center relative z-10">
        <h2 className="font-default text-sm md:text-base font-bold tracking-widest text-muted-foreground uppercase">
          Certified Quality & Trusted Partners
        </h2>
      </div>

      {}
      <div className="w-full relative overflow-hidden group flex items-center">
        {}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none"></div>

        {}
        <div className="animate-ticker items-center">
          {tickerItems.map((partner, i) => <div key={`${partner.id}-${i}`} data-index={i} className="flex-shrink-0 flex items-center justify-center w-48 md:w-64 h-24 px-8 cursor-pointer">
              <img src={partner.logo} alt={partner.name} className="max-w-full max-h-12 object-contain grayscale opacity-60 transition-all duration-500 ease-in-out hover:grayscale-0 hover:opacity-100 hover:scale-105" />
            </div>)}
        </div>
      </div>

      {}
      <Separator className="absolute bottom-0 w-full bg-border h-[1px]" />
    </section>;
}